import type { Node } from 'slate';
import { Element } from 'slate';

import { BULLETED_LIST, NUMBERED_LIST } from 'constants/editors';

import type { ListsEditor } from '../types';
import { ListType } from '../types';

/**
 * Returns the "type" of a given list node.
 */
export const getListType = (editor: ListsEditor, node: Node): ListType => {
  const isElement = Element.isElement(node);

  if (isElement && (editor.isListNode(node, ListType.ORDERED) || node.type === NUMBERED_LIST)) {
    return ListType.ORDERED;
  }

  if (isElement && (editor.isListNode(node, ListType.UNORDERED) || node.type === BULLETED_LIST)) {
    return ListType.UNORDERED;
  }

  // This should never happen.
  return ListType.UNORDERED;
};

export default getListType;